import globalData from "./global-data.min.js";

const routes = globalData.routes;
var serializeForm = function (form) {
	var obj = {};
  
	var formData = new FormData(document.querySelector(form));
 
	for (var key of formData.keys()) {
		obj[key] = formData.get(key);
	}
 
    return new URLSearchParams(obj).toString()
};

var theoremCart =  {
    getCart: async function() {
        const response = await fetch(routes.shop_url+'/cart.js', {
            headers: {
                'Content-Type': 'application/json'
            }
        }); 
        const text = await response.json();
        return text;

        // EXAMPLE

        // theoremCart.getCart()
        // .then(data)
        // .catch((error) => console.error('Error:', error));
    },
    addItem: async function(productDetails) {
        const response = await fetch(routes.shop_url+'/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(productDetails)
        });
        const text = await response.json();
        return text;

        // EXAMPLE

        // theoremCart.addItem({
        //     'items': [{
        //         'id': variantId,
        //         'quantity': quantity,
        //         'properties': properties
        //     }]
        // })
        // .then(data => {
        //     if(!data.status) {
        //         // SUCCESS
        //         document.querySelectorAll('.j-qb-toggle').forEach(function(draw){ 
        //             draw.parentElement.parentElement.classList.remove('active');
        //         });
        //         document.dispatchEvent(new Event('cartUpdated'));
        //         console.log(data);
        //     } else {
        //         // ERROR
        //         alert(`${data.message}: ${data.description}`);    
        //     }
        // })
    },
    updateItem: async function(variantId, productQuantity) { 
        const items = {};
        items[variantId] = productQuantity;
        const response = await fetch(routes.shop_url+'/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({updates: items})
        });
        const text = await response.json();
        return text;
    },
    addNote: async function(cartNote) { 
        const response = await fetch(routes.shop_url+'/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({note: cartNote})
        });
        const text = await response.json();
        return text;
    },
    addAttributes: async function(attributeObj) { 
        const response = await fetch(routes.shop_url+'/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                attributes: attributeObj
            })
        });
        const text = await response.json();
        return text;
    },
    changeItem: async function(cartLineKey, productQuantity, properties = {},  selling_plan = null) {
        const response = await fetch(routes.shop_url+'/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                'id': cartLineKey,
                'quantity': productQuantity,
                'properties': properties,
                'selling_plan': selling_plan
            })
            
        });
        const text = await response.json();
        return text;
    },
    clearItems: async function() {
        const response = await fetch(routes.shop_url+'/cart/clear.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        }); 
        const text = await response.json();
        return text;
    },
    postShippingRates: async function(formSelector) {
        const response = await fetch(routes.shop_url+'/cart/prepare_shipping_rates.json?'+serializeForm(formSelector), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        const text = await response.json();
        setTimeout(() => {
            theoremCart.getShippingRates(formSelector)
        }, "1000");
    },
    getShippingRates: async function(formSelector) {
        const response = await fetch(routes.shop_url+'/cart/async_shipping_rates.json?'+serializeForm(formSelector), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        const text = await response.json();
        if (response != null) {
            return text;
        } else {
            setTimeout(() => {
                theoremCart.getShippingRates(formSelector)
            }, "1000");
        }
        
    }

};
window.theoremCart = window.theoremCart || theoremCart;



